module.exports = __webpack_public_path__ + "img/caminhao-vermelho.e07d4c13.png";